import moment from "moment-timezone";

import {TIME_FORMAT} from "config/constants";
import {TimeConstraint} from "v2/api/Records";

const formatTime = (timeStr) => {
  const today = moment();
  const [hours, minutes, seconds] = timeStr.split(":");
  return today
        .hours(hours)
        .minutes(minutes)
        .seconds(seconds)
        .format(TIME_FORMAT);
};

export const apiTimeConstraint = (item) => {
  return new TimeConstraint(item);
};

export const formatTimeConstraints = (items, forMarkdown=false) => {
  return items
        .map(item => {
          const label = forMarkdown ? `- **${item.label}**` : item.label;
          const weekday = item.weekday || "every day";

          const timeStart = item.timeStart && formatTime(item.timeStart);
          const timeEnd = item.timeEnd && formatTime(item.timeEnd);

          let timeLabel = "";
          if (timeStart && timeEnd) {
            timeLabel = `: Between ${timeStart} and ${timeEnd}`;
          } else if (timeStart) {
            timeLabel = `: After ${timeStart}`;
          } else if (timeEnd) {
            timeLabel = `: Before ${timeEnd}`;
          }

          return `${label} ${weekday}${timeLabel}`;
        })
        .toJS()
        .join("\n");
};

export default {
  apiTimeConstraint,
  formatTimeConstraints,
};



/** WEBPACK FOOTER **
 ** ./src/app/v2/api/TimeConstraints.js
 **/